import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from "../auth/auth.service";
import { selectIsOauthTokenValid } from "../../stores/auth/auth.selector";
import { Store } from "@ngrx/store";
import { AppState } from "../../stores/app.state";

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {

  constructor(private router: Router, private authService: AuthService, private store: Store<AppState>) {
  }

  canActivate(): boolean {
    const isOauthTokenValid = this.store.selectSignal(selectIsOauthTokenValid)();
    // console.log("AuthGuard.isOauthTokenValid(): ", isOauthTokenValid)
    if (isOauthTokenValid) {
      return true;
    } else {
      this.authService.redirectToExternalLogin();
      return false;
    }
  }
}
